import React, {Component} from 'react';
import ModalCreateCoupon from "./components/ModalCreateCoupon";
import ListCoupons from './components/ListCoupons';
import PageItemCoupons from './components/PageItemCoupons';
import {_getListCoupons} from "../../../../../services/apis/AdminCouponServices";
import ControlCoupon from './components/ControlCoupon';
import {changeQuerySearch, parseSearchQuery} from "../../../../../helpers/routes/RouterHelper"
import {Alert} from "reactstrap";


const getInitPage = () => {
    const parsed = parseSearchQuery();
    return !!parsed.page ? parseInt(parsed.page, 10) : 1;
}


class CouponPage extends Component {
    state = {
        coupons: [],
        error: '',
        modal: false,
        pagination: {
            page: getInitPage(),
            pages: 1,
            limit: 1000,
            total: 0
        }
    }

    componentDidMount() {
        this.fetchListCoupons();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.pagination.page !== prevState.pagination.page) {
            this.fetchListCoupons();
        }
    }

    fetchListCoupons = () => {
        const {page, limit} = this.state.pagination;

        _getListCoupons({page, limit})
            .then(result => {
                const {success, data, message} = result;

                if (success) {
                    this.setState({
                        coupons: data.docs,
                        pagination: {
                            page,
                            pages: data.pages,
                            limit,
                            total: data.total
                        },
                        error: ''
                    });
                } else {
                    this.setState({
                        error: message
                    });
                }
            }).catch(err => {
            this.setState({
                error: err.message
            });
        });
    }

    showModalNewCoupon = () => {
        this.setState({
            modal: true
        });
    }

    hideModalNewCoupon = () => {
        this.setState({
            modal: false
        });
    }

    setPage = (indexPage) => {
        const {limit, pages, total} = this.state.pagination;
        const pagination = {
            page: indexPage,
            pages,
            limit,
            total
        }
        changeQuerySearch({page: indexPage});
        this.setState({pagination});
    }

    setListCoupons = (coupons) => {
        this.setState({coupons});
    }

    render() {
        const {pagination, coupons, error} = this.state;
        const toggle = {
            showModalNewCoupon: this.showModalNewCoupon,
            hideModalNewCoupon: this.hideModalNewCoupon,
            fetchListCoupons: this.fetchListCoupons
        }

        return (
            <div>
                {
                    !!error ? <Alert color="danger">{error}</Alert> :
                        <div className="CouponPage">
                            <div className="ContentCoupon">
                                <ControlCoupon showModalNewCoupon={this.showModalNewCoupon}/>

                                <ListCoupons coupons={coupons} fetchListCoupons={this.fetchListCoupons}
                                             setListCoupons={this.setListCoupons}/>

                                <PageItemCoupons pagination={pagination} setPage={this.setPage}/>
                            </div>

                            <ModalCreateCoupon modal={this.state.modal} toggle={toggle}/>
                        </div>
                }
            </div>
        );
    }
}

export default CouponPage;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/coupon/CouponPage/CouponPage.js